<div class="row">
  <div class="col-md-6">
    <app-form-group><label>Id</label><input class="form-control" [(ngModel)]="linerService['id']" disabled required>
    </app-form-group>
    <app-form-group><label>Code</label><input class="form-control" [(ngModel)]="linerService.code" required>
    </app-form-group>
    <app-form-group><label>Name</label><input class="form-control" [(ngModel)]="linerService.name" required>
    </app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group label="Stevedore organisation (mandatory for MSAT)">
      <app-search [ngModel]="linerService.stevedoreOrganisationShortName" [searchFunction]="searchOrganisation"
                  (ngModelChange)="setStevedoreOrganisationShortName($event)" [resultFormatter]="formatter"
                  placeholder="Find stevedore organisation by short name">
      </app-search>
    </app-form-group>
    <app-form-group label="Carrier organisations (for MSAT, please also provide EORI number for each)">
      <app-multi-search [ngModel]="linerService.carrierOrganisationsShortNames" [searchFunction]="searchOrganisation"
                        (ngModelChange)="setCarrierOrganisationsShortNames($event)" [resultFormatter]="formatter"
                        placeholder="Find carrier organisation by short name">
      </app-multi-search>
    </app-form-group>
    <app-form-group label="Carrier organisations EORI (mandatory for harbour dues)">
      <app-multi-search [ngModel]="linerService['carrierOrganisationsEoriNumbers']" [searchFunction]="searchCarriers"
                        (ngModelChange)="setCarrierOrganisationsEoriNumbers($event)" [resultFormatter]="carrierFormatter"
                        placeholder="Find carrier by name or EORI number">
      </app-multi-search>
    </app-form-group>
    <app-form-group><label>Port code (mandatory for Harbour Dues)</label>
      <app-select id="port" [ngModel]="linerService.harbourDuesPort" [optionsProvider]="searchPortsOfCall"
                  (ngModelChange)="setPortUnloCode($event)"
                  [addSelectedIfNotExists]="false" placeholder="– Select a port –">
      </app-select>
    </app-form-group>
  </div>
</div>
